import { getTotalServiceTime } from './getTotalServiceTime.js';
import { getTotalTravelTime } from './getTotalTravelTime.js';
import { isInterventionStop } from './isInterventionStop.js';

// Keep in sync with VEHICLE_MAX_ROUTE_DURATION_MINUTES in optimizeRoute.ts (7h + 60 - 30).
const VEHICLE_MAX_ROUTE_DURATION_MINUTES = 7 * 60 + 60 - 30;

type WorkingDayStop = {
  type?: string | null;
  ticketId?: string | null;
  travelDurationMinutes?: number | null;
  serviceDurationMinutes?: number | null;
  lat?: number | null;
  lng?: number | null;
};

type WorkingDayRoute = {
  stops?: WorkingDayStop[] | null;
};

export function getRouteMinutesForRoute(route: WorkingDayRoute | undefined): number {
  if (!route) return 0;
  const nonInterventionStops = route.stops?.filter(stop => !isInterventionStop(stop));
  return (
    getTotalTravelTime(route.stops ?? undefined) +
    getTotalServiceTime(nonInterventionStops as Parameters<typeof getTotalServiceTime>[0])
  );
}

export function getRoutePlanningWorkingDayStats(planning: { routes?: WorkingDayRoute[] | null }) {
  const routes = planning.routes ?? [];
  if (routes.length === 0) {
    return {
      longestWorkingDayMinutes: 0,
      averageOvertimeMinutes: 0,
    };
  }

  let longestWorkingDayMinutes = 0;
  let overtimeSum = 0;

  for (const route of routes) {
    const routeMinutes = getRouteMinutesForRoute(route);
    longestWorkingDayMinutes = Math.max(longestWorkingDayMinutes, routeMinutes);
    overtimeSum += Math.max(0, routeMinutes - VEHICLE_MAX_ROUTE_DURATION_MINUTES);
  }

  return {
    longestWorkingDayMinutes,
    averageOvertimeMinutes: overtimeSum / routes.length,
  };
}
